import InfoWindow from 'components/Windows/InfoWindow/InfoWindow'
import { useIntl } from 'react-intl'

export default function Message({ message, removeMessage }) {
    const { code, type } = message
    const intl = useIntl()
    const handleRemoveMessage = () => {
        removeMessage(message)
    }

    if (type === 'ERROR') {
        const description = intl.formatMessage({
            id: `windows.error.${code}`,
            defaultMessage: intl.formatMessage({ id: 'windows.error.somethingWrong' }),
        })
        return <InfoWindow color={'red'} description={description} withTimer onClose={handleRemoveMessage} />
    }
    if (type == 'SUCCESS') {
        const description = intl.formatMessage({
            id: `windows.success.${code}`,
            defaultMessage: intl.formatMessage({ id: 'windows.success.successful' }),
        })
        return <InfoWindow color={'green'} description={description} withTimer onClose={handleRemoveMessage} />
    }
    if (type == 'NOTIFICATION_PURPLE') {
        const description = intl.formatMessage({
            id: `windows.notification.${code}`,
        })
        return <InfoWindow color={'purple'} description={description} withTimer onClose={handleRemoveMessage} />
    }
}
